// extracted by mini-css-extract-plugin
export default {"AddToCalendarButtons__container":"AddToCalendarButtons_AddToCalendarButtons__container__WRpoS","AddToCalendarButtons__icon":"AddToCalendarButtons_AddToCalendarButtons__icon__3mnoS"};